/*
 * File: table-data.ts
 * File Created: 2024-01-11 10:29:08
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-01-19 10:44:50
 * Modified By: Val Liu
 * -----
 */

export const data = [
    {
        name: "Val",
        age: 45,
        image: "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/496c8d1b-6247-40a0-8753-a3458d353a8c/dg4y0mi-60c7532e-f1e0-4a8b-b805-357e059d4157.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzQ5NmM4ZDFiLTYyNDctNDBhMC04NzUzLWEzNDU4ZDM1M2E4Y1wvZGc0eTBtaS02MGM3NTMyZS1mMWUwLTRhOGItYjgwNS0zNTdlMDU5ZDQxNTcucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.KSz-_aY6L1RvrY7G_NWsloZOChB2ROt-8n1xGv9aPvU",
        description: "松山區",
        username: "Val",
        boolean: true,
        memo: null,
        createdAt: new Date(),
        updatedAt: new Date(),
    },
    {
        name: "UT",
        age: 43,
        image: "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/496c8d1b-6247-40a0-8753-a3458d353a8c/dg4rck4-a387f383-caf7-4e06-9cd2-cb10e8ccf50b.png/v1/fill/w_894,h_894,q_70,strp/shadow_by_amenale_dg4rck4-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTAyNCIsInBhdGgiOiJcL2ZcLzQ5NmM4ZDFiLTYyNDctNDBhMC04NzUzLWEzNDU4ZDM1M2E4Y1wvZGc0cmNrNC1hMzg3ZjM4My1jYWY3LTRlMDYtOWNkMi1jYjEwZThjY2Y1MGIucG5nIiwid2lkdGgiOiI8PTEwMjQifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.QnPLyhUuOJjzRqCuN2zlbRbZ2fWrsLiX1N_14w73huM",
        description: "古亭區",
        username: "U.T.",
        boolean: false,
        memo: null,
        createdAt: new Date(),
        updatedAt: new Date(),
    },
    {
        name: "Fayu",
        age: 52,
        image: "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/496c8d1b-6247-40a0-8753-a3458d353a8c/dg4rcml-70eaa050-ab62-4fe2-85fd-971e3b0686b1.png/v1/fill/w_894,h_894,q_70,strp/shadow_by_amenale_dg4rcml-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTAyNCIsInBhdGgiOiJcL2ZcLzQ5NmM4ZDFiLTYyNDctNDBhMC04NzUzLWEzNDU4ZDM1M2E4Y1wvZGc0cmNtbC03MGVhYTA1MC1hYjYyLTRmZTItODVmZC05NzFlM2IwNjg2YjEucG5nIiwid2lkdGgiOiI8PTEwMjQifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.Cfvwj_bi1hNRdisFyX0QBzuS6Hr7gKtN51Kvxzb_CS4",
        description: "內湖區",
        username: "Fayu",
        boolean: true,
        memo: null,
        createdAt: new Date(),
        updatedAt: new Date(),
    },
    {
        name: "Tina",
        age: 36,
        image: "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/488436b2-46df-43a8-90e5-8e74d2ecbc96/dg8bt6u-2c76d2eb-b366-45d4-b7ef-0860d25d6f37.jpg/v1/fill/w_1024,h_1360,q_75,strp/beautiful_anime_girl_illustration_by_dendyh7_dg8bt6u-fullview.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTM2MCIsInBhdGgiOiJcL2ZcLzQ4ODQzNmIyLTQ2ZGYtNDNhOC05MGU1LThlNzRkMmVjYmM5NlwvZGc4YnQ2dS0yYzc2ZDJlYi1iMzY2LTQ1ZDQtYjdlZi0wODYwZDI1ZDZmMzcuanBnIiwid2lkdGgiOiI8PTEwMjQifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.5IqSMn5Bjh_SxNjlojNC-L6zQ8PP699hwotAsIDK-Zo",
        description: "南港區",
        username: "Tina",
        boolean: false,
        memo: null,
        createdAt: new Date(),
        updatedAt: new Date(),
    },
];
